export default (value, options) => {
  const filterAirportOptions = option =>
    option.name.toLowerCase().includes(value) ||
    option.id.toLowerCase().includes(value)

  return options.filter(filterAirportOptions)
}
